import React, { useState } from "react";
import BookDemo from "../components/BookDemo";
import "../styles/CareerGuidance.css";

export default function CareerGuidance() {
  const [showDemo, setShowDemo] = useState(false);

  return (
    <div className="career-page">

      {/* HERO */}
      <section className="career-hero">
        <div className="career-hero-content">
          <button className="primary-btn" onClick={() => setShowDemo(true)}>
            Book Career Session
          </button>
        </div>
      </section>

      {/* ...rest of your page stays SAME... */}
      <section className="career-section">

        <h1>Career Guidance & Mentorship</h1>
        <p>
          Sprout Knowledge Solutions helps homemakers, job seekers, and career
          aspirants discover the right career path, reskill with confidence,
          and build a sustainable future.
        </p>

        <h2>Why Career Guidance Matters</h2>
        <p className="section-desc">
          Many people feel stuck, confused, or unsure about their future.
          Professional career guidance helps you take informed decisions and
          move forward with clarity and confidence.
        </p>

        <div className="career-grid">
          <div className="career-card">
            <h3>🎯 Career Clarity</h3>
            <p>
              Identify suitable career options based on your background,
              interests, and lifestyle.
            </p>
          </div>

          <div className="career-card">
            <h3>📈 Skill-Based Direction</h3>
            <p>
              Learn which in-demand skills can help you restart or grow your
              career.
            </p>
          </div>

          <div className="career-card">
            <h3>💼 Job & Business Options</h3>
            <p>
              Explore job roles, freelancing, work-from-home, or small business
              opportunities.
            </p>
          </div>

          <div className="career-card">
            <h3>🚀 Confidence Building</h3>
            <p>
              Overcome fear, self-doubt, and career gaps with structured
              mentoring.
            </p>
          </div>
        </div>
      </section>

      {/* ================= WHO CAN BENEFIT ================= */}
      <section className="career-section light">
        <h2>Who Can Benefit?</h2>

        <div className="career-benefit-wrapper">
          {/* LEFT */}
          <ul className="career-list">
            <li>✔ Homemakers planning to restart their career</li>
            <li>✔ Individuals who couldn’t get a job earlier</li>
            <li>✔ People confused about future career choices</li>
            <li>✔ Freshers unsure which path to choose</li>
            <li>✔ Professionals planning a career switch</li>
            <li>✔ Anyone looking for guidance & motivation</li>
          </ul>

          {/* RIGHT IMAGE */}
          <div className="career-benefit-image">
            <img
              src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d"
              alt="Career Guidance"
            />
          </div>
        </div>
      </section>

      {/* ================= PROCESS ================= */}
      <section className="career-section">
        <h2>Our Career Guidance Process</h2>

        <div className="process-steps">
          <div className="step">
            <span>1</span>
            <h4>Career Assessment</h4>
            <p>Understand your interests, strengths, and current situation.</p>
          </div>

          <div className="step">
            <span>2</span>
            <h4>Personal Counseling</h4>
            <p>One-on-one discussion with expert career mentors.</p>
          </div>

          <div className="step">
            <span>3</span>
            <h4>Skill & Role Mapping</h4>
            <p>Identify suitable skills, courses, and career options.</p>
          </div>

          <div className="step">
            <span>4</span>
            <h4>Action Plan</h4>
            <p>Clear roadmap for jobs, freelancing, or entrepreneurship.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="career-cta">
        <h2>Take the First Step Toward Your Future</h2>
        <p>
          It’s never too late to start again. Get expert guidance and move
          forward with confidence.
        </p>

        <button className="primary-btn" onClick={() => setShowDemo(true)}>
          Schedule Career Guidance
        </button>
      </section>

      {/* DEMO MODAL */}
      {showDemo && <BookDemo onClose={() => setShowDemo(false)} />}

    </div>
  );
}
